<template>
  <div>
    <form @submit.prevent="login" class="auth-form">
      <app-input-status
        label="ID"
        color="blueSecondary"
        :optional="false"
        :message="emailError"
        :validationError="emailError ? true : false"
        :success="emailMeta.valid"
      />
      <input
        placeholder="IDを入力ください"
        class="w-full h-10 border rounded-full focus:outline-none px-5 border-blueSecondary"
        :class="emailError ? 'bg-blue bg-opacity-25' : ''"
        name="email"
        v-model="email"
      />

      <app-input-status
        label="パスワード"
        color="blueSecondary"
        class="mt-5"
        :message="passwordError"
        :optional="false"
        :validationError="passwordError ? true : false"
        :success="passwordMeta.valid"
      />

      <div class="relative w-full">
        <div class="absolute inset-y-0 right-0 flex items-center pr-3">
          <font-awesome-icon
            :icon="passwordInputType == 'text' ? 'eye' : 'eye-slash'"
            @click="togglePasswordInputType"
            :style="{ color: '#4F82E6' }"
          />
        </div>
        <input
          placeholder="パスワードを入力ください"
          class="h-10 border appearance-none border-blueSecondary rounded-full w-full px-5 leading-tight focus:outline-none"
          :class="passwordError ? 'bg-blue bg-opacity-25' : ''"
          id="password"
          name="password"
          v-model="password"
          autocomplete="off"
          :type="passwordInputType"
        />
      </div>

      <button
        class="border-4 rounded-full h-10 border-blueSecondary mt-10 bg-white"
        style="width: 160px; float: right"
        type="submit"
        :disabled="isLoginBtnDisabled"
      >
        <div class="flex flex-row items-center justify-center">
          <login-icn class="mr-1" />
          <span class="font-bold text-lg text-blueSecondary leading-none"
            >ログイン</span
          >
        </div>
      </button>
    </form>

    <AuthTopLeft class="fixed top-0 left-0" />
    <AuthLogoProvider class="fixed right-0" />
    <AuthBottomLeft class="fixed bottom-0 left-0" />
    <AbleLogo class="fixed bottom-0 left-0" />
    <AuthBottomRight class="fixed bottom-0 right-0" />
  </div>
</template>
<script>
import { useAuth } from '@/services/useAuth'

import AuthTopLeft from '@/assets/icons/auth-top-left.svg?inline'
import AuthBottomLeft from '@/assets/icons/auth-bottom-left.svg?inline'
import AuthBottomRight from '@/assets/icons/auth-bottom-right.svg?inline'
import AbleLogo from '@/assets/icons/able-logo.svg?inline'
import LoginIcn from '@/assets/icons/login.svg?inline'
import AppInputStatus from '@/components/ui/AppInputStatus'
import AuthLogoProvider from '@/components/provider/authLogo/AuthLogoProvider'

export default {
  name: 'Auth',

  components: {
    AuthTopLeft,
    AuthBottomRight,
    AuthBottomLeft,
    AbleLogo,
    AppInputStatus,
    LoginIcn,
    AuthLogoProvider,
  },

  setup() {
    return { ...useAuth() }
  },
}
</script>
<style lang="scss">
.auth-form {
  width: 664px;
  position: fixed;
  right: 62px;
  top: 312px;
  z-index: 999;
}
</style>
